import { redirect } from "@tanstack/react-router"
import { toast } from "react-toastify"
import { organizationUserCan } from "./organizationUserCan"
import { Entities, Permissions } from "@/types/permissions"

export const checkOrganizationPermissions = (
  action: Permissions,
  entity: Entities,
) => {
  if (!organizationUserCan(action, entity)) {
    toast.error(
      "Je hebt geen toegang tot deze pagina. Neem contact op met de beheerder.",
    )

    throw redirect({ to: "/beheer" })
  }
}
